module.exports = __webpack_public_path__ + "img/music_on.0ec2c733.svg";